/*
 * (c) Meta Platforms, Inc. and its affiliates.
 */

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ExplorerPage from "./components/pages/ExplorerPage";
import AboutPage from "./components/pages/AboutPage";
import "maplibre-gl/dist/maplibre-gl.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route index element={<ExplorerPage />} />
        <Route path="about" element={<AboutPage />} />
      </Routes>
    </Router>
  );
}

export default App;
